import { CohortEnum } from '@eigtech/auth0-types'
import { ExportImagesRequest, ExportImagesResponse } from '@eigtech/documents-types'
import { getCornKernels } from '@eigtech/shared-corn'
import { contextualGet, queryOptions, useMutation, useQueryClient } from '@eigtech/ui-shared-api'
import { documentsBasePath, documentsQueryKeys } from './constants'
import { secondsToMilliseconds } from '@eigtech/ui-shared-dates'

const exportImages = ({ cohort, entityId }: ExportImagesRequest) =>
  contextualGet<ExportImagesResponse>(`${documentsBasePath}/${cohort}/${entityId}/export`)

const exportImagesQueryOptions = (props: ExportImagesRequest) =>
  queryOptions({
    queryKey: documentsQueryKeys.imagesExport(props.entityId),
    queryFn: () => exportImages(props),

    // slightly shorter than the default `URL_EXPIRATION_IN_SECONDS`
    staleTime: secondsToMilliseconds(275),
  })

export const useExportImages = (props: Pick<ExportImagesRequest, 'cohort'>) => {
  const queryClient = useQueryClient()

  return useMutation({
    retry: false,
    mutationFn: async (request: Omit<ExportImagesRequest, 'cohort'>) => {
      const { resourceId } = getCornKernels(request.entityId)
      const url = await queryClient.fetchQuery(exportImagesQueryOptions({ ...props, ...request }))
      if (!url) return

      const link = document.createElement('a')
      link.href = url
      link.download = `${resourceId}-${new Date().getTime()}.zip`
      link.click()
    },
  })
}

export const useExportCsrImages = () => useExportImages({ cohort: 'csr' })

export const useExportEstimatorImages = () => useExportImages({ cohort: 'estimator' })

export function useExportTplapImages(cohort: Extract<CohortEnum, 'insured' | 'technician'>) {
  return useExportImages({ cohort })
}
